import { render, staticRenderFns } from "./authIndex.vue?vue&type=template&id=4f18e296&scoped=true"
import script from "./authIndex.vue?vue&type=script&lang=js"
export * from "./authIndex.vue?vue&type=script&lang=js"
import style0 from "./authIndex.vue?vue&type=style&index=0&id=4f18e296&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18e296",
  null
  
)

export default component.exports